/**
 * 微信朋友圈
 */
import http from './http';

// 查询绑定信息
export const queryBindInfo = () => {
  return http({
    method: 'GET',
    url: '/moment-wechat-realation/query',
  });
};

// 更新绑定信息
export const updateBindInfo = (data) => {
  return http({
    method: 'POST',
    url: '/moment-wechat-realation/bind',
    data,
  });
};

// 查询定时任务列表
export const getTaskTemplateList = () => {
  return http({
    method: 'GET',
    url: '/moment-task-card/templates',
  });
};

// 更新定时任务状态
export const updateTaskItemStatus = (data) => {
  return http({
    method: 'POST',
    url: '/moment-task-card/template/status',
    data,
  });
};

// 获取定时任务详情
export const getTaskItemDetail = (id: number) => {
  return http({
    method: 'GET',
    url: `/moment-task-card/template/${id}`,
  });
};

// 获取营销配置
export const getMarketingConfig = () => {
  return http({
    method: 'GET',
    url: '/moment-task-card/marketing/config',
  });
};

// 创建定时任务
export const createTaskItem = (data) => {
  return http({
    method: 'POST',
    url: '/moment-task-card/template/save',
    data,
  });
};

// 更新定时任务详情
export const updateTaskItemDetail = (data) => {
  return http({
    method: 'POST',
    url: '/moment-task-card/template/update',
    data,
  });
};

// 删除定时任务
export const deleteTaskItem = (id: number) => {
  return http({
    method: 'DELETE',
    url: `/moment-task-card/template/${id}`,
  });
};

// 查询发布记录
export const getPublishRecordList = (data) => {
  return http({
    method: 'POST',
    url: '/moment-task-card/page',
    data,
  });
};

// 获取发布详情
export const getPublishRecordDetail = (id: number) => {
  return http({
    method: 'GET',
    url: `/moment-task-card/detail/${id}`,
  });
};

// 更新发布详情
export const updatePublishRecordDetail = (data) => {
  return http({
    method: 'POST',
    url: '/moment-task-card/edit',
    data,
  });
};

// 创建朋友圈
export const createPublishRecord = (data) => {
  return http({
    method: 'POST',
    url: '/moment-task-card/create/momentTask',
    data,
  });
};

// 发布朋友圈
export const pushPublishRecord = (data) => {
  return http({ method: 'POST', url: '/moment-task-card/push/momentTask', data });
};

// 删除发布记录
export const deletePublishRecord = (id: number) => {
  return http({
    method: 'DELETE',
    url: `/moment-task-card/task/${id}`,
  });
};

export const getWeChatQRCode = () => {
  return http({
    method: 'GET',
    url: '/moment-task-card/getWeChatQrcode',
  });
};
